import { Grid, Typography, useTheme, useMediaQuery } from '@mui/material'
import { useNavigate, useParams } from 'react-router-dom'
import { PageContainer, StyledCard, SectionHeader, PrimaryButton } from '../components/ui/StyledComponents'

function MyTasksPage() {
  const navigate = useNavigate()
  const { teacherId } = useParams()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  // Navigate to ClassesPage to take attendance
  const handleTakeAttendance = () => {
    navigate(`/teacher/${teacherId}/attendance`) // This will navigate to the ClassesPage
  }

  // Sample tasks data - you can replace this with actual data from your API
  const tasks = [
    { id: 1, title: 'Record Attendance & Progress', description: 'Take attendance, Enter Quran/Greenbook progress and notes for today\'s classes', action: handleTakeAttendance },
    { id: 2, title: 'Take Progress Notes', description: 'Enter and manage notes on student performance', action: () => navigate('/student-notes') },
    // { id: 3, title: 'Check Messages', description: 'View and respond to messages from students, parents, and other teachers', action: () => navigate(`/teacher/${teacherId}/messages`) },
  ]

  return (
    <PageContainer>
      <Grid container spacing={{ xs: 2, sm: 3 }}>
        <Grid item xs={12}>
          <SectionHeader sx={{ fontSize: { xs: '1.5rem', sm: '2rem', md: '2.125rem' } }}>
            My Tasks
          </SectionHeader>
        </Grid>

        {tasks.map(task => (
          <Grid item xs={12} key={task.id}>
            <StyledCard sx={{ p: { xs: 2, sm: 2.5, md: 3 } }}>
              <Typography 
                variant="h6" 
                gutterBottom
                sx={{ 
                  fontSize: { xs: '1.125rem', sm: '1.25rem', md: '1.5rem' },
                  mb: { xs: 1, sm: 1.5 },
                }}
              >
                {task.title}
              </Typography>
              <Typography 
                variant="body1" 
                paragraph
                sx={{ 
                  fontSize: { xs: '0.875rem', sm: '1rem' },
                  mb: { xs: 2, sm: 2.5 },
                }}
              >
                {task.description}
              </Typography>
              <PrimaryButton
                variant="contained"
                onClick={task.action}
                fullWidth={isMobile}
                sx={{
                  fontSize: { xs: '0.875rem', sm: '1rem' },
                  padding: { xs: '10px 16px', sm: '12px 24px' },
                }}
              >
                {task.title}
              </PrimaryButton>
            </StyledCard>
          </Grid>
        ))}
      </Grid>
    </PageContainer>
  )
}

export default MyTasksPage
